export const PlagiarismCheckerIcon = (props: { color?: string }) => {
    return (
        <svg
            width="16"
            height="19"
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="plagiarism-icon-wrapper"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.59999 1.11765C1.30544 1.11765 1.06666 1.36784 1.06666 1.67647V17.3235C1.06666 17.6322 1.30543 17.8824 1.59999 17.8824H6.93326C7.22781 17.8824 7.46659 18.1325 7.46659 18.4412C7.46659 18.7498 7.22781 19 6.93326 19H1.59999C0.716339 19 0 18.2494 0 17.3235V1.67647C0 0.75059 0.716333 0 1.59999 0H12.2667C13.1504 0 13.8667 0.750594 13.8667 1.67647V7.26471C13.8667 7.57334 13.6279 7.82353 13.3333 7.82353C13.0388 7.82353 12.8 7.57334 12.8 7.26471V1.67647C12.8 1.36784 12.5612 1.11765 12.2667 1.11765H1.59999ZM6.40004 13.0765C6.40004 10.7926 8.16703 8.94118 10.3467 8.94118C12.5264 8.94118 14.2933 10.7926 14.2933 13.0765C14.2933 14.0116 13.9966 14.8748 13.4972 15.5674L15.8453 18.0476C16.0527 18.2667 16.0514 18.6206 15.8423 18.8379C15.6332 19.0553 15.2955 19.0538 15.088 18.8347L12.7455 16.3604C12.0809 16.8941 11.2488 17.2118 10.3467 17.2118C8.16703 17.2118 6.40004 15.3603 6.40004 13.0765ZM10.3467 10.0588C8.75613 10.0588 7.4667 11.4099 7.4667 13.0765C7.4667 14.7431 8.75613 16.0941 10.3467 16.0941C11.1467 16.0941 11.8698 15.753 12.3923 15.2006L12.3923 15.2006C12.9086 14.6548 13.2267 13.9051 13.2267 13.0765C13.2267 11.4099 11.9373 10.0588 10.3467 10.0588Z"
                fill={props.color ?? '#4B286D'}
            />
        </svg>
    )
}
